import React, { createContext, useContext } from 'react';
import { useAuthContextLogic } from '@/contexts/hooks/useAuthContextLogic';
import TermsDialog from '@/components/TermsDialog';
import { Loader2 } from '@/icons';

const AuthContext = createContext(null);

function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export { useAuth };

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', backgroundColor: 'transparent', position: 'fixed', top: 0, left: 0, zIndex: 9999 }}>
    <Loader2 style={{ height: '3rem', width: '3rem', animation: 'spin 1s linear infinite' }} />
  </div>
);

function AuthProvider({ children }) {
  const {
    contextValue,
    user,
    loading,
    showTermsDialog,
    handleAcceptTerms,
    closeTermsDialog,
    supabaseConfigured,
    initialAuthCheckComplete
  } = useAuthContextLogic();
  
  if (loading || !supabaseConfigured || !initialAuthCheckComplete) {
    return <LoadingFallback />;
  }

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
      {supabaseConfigured && user && contextValue.onboardingStatus && (
        <TermsDialog 
          isOpen={showTermsDialog}
          onClose={closeTermsDialog} 
          onAccept={handleAcceptTerms}
          termsAgreed={contextValue.onboardingStatus.termsAgreed}
          currentTermsVersion={contextValue.currentTermsVersion}
          profileTermsVersion={contextValue.profile?.terms_version_agreed}
        />
      )}
    </AuthContext.Provider>
  );
}

export { AuthProvider };
  
